// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__j7FyF","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__9BNNV"};